import Vue from "vue";
import Router from "vue-router";

import PageNotFound from "../views/NotFoundPage.vue";
import AuthLogin from "../views/Auth/Login.vue";

import ConfigRoutes from "./config.routes";
import DashboardRoutes from "./dashboard.routes";
import PackageRoutes from "./package.routes";
import OrganizationRoutes from "./organization.routes";
import UserRoutes from "./user.routes";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/auth/login",
      component: AuthLogin
    },
    DashboardRoutes,
    PackageRoutes,
    OrganizationRoutes,
    UserRoutes,
    ConfigRoutes,
    { path: "*", component: PageNotFound }
  ],
});
